<div class="sdk-policy-dialog flex flex-col w-full dialog-content">
  <div class="p-6 flex flex-col">
    <span class="text-lg font-inter font-bold text-black-800">Great news!</span>
    <span class="text-sm font-inter pt-2 text-black-800">We found the following Applied Epic Client and Policies, please select a Policy you'd like to fetch the data for.</span>
  </div>
  <div class="flex flex-col w-full font-inter overflow-y-auto p-6 bg-gray-20">
    <div *ngIf="clients?.length === 1" class="text-md font-inter pb-2.5 text-black-800">
      Policies for {{ clients[0].AccountName }}:
    </div>
    <div *ngIf="clients?.length > 1">
      <xilo-accordion class="flex flex-col rounded bg-white mt-2 " *ngFor="let client of clients; let i = index">
        <xilo-accordion-panel [open]="false">
          <xilo-accordion-title [noBorder]="true" paddingClass="p-3">{{ client.AccountName ? client.AccountName : 'Client' }}</xilo-accordion-title>
          <xilo-accordion-content paddingClass="px-3 pb-3">
            <div class="flex flex-row flex-wrap">
              <div class="policy-item"><span class="font-semibold">Account Name:</span> {{ client.AccountName }}</div>
              <div class="policy-item"><span class="font-semibold">Phone Number:</span> {{ client.AccountValue.Number }}</div>
              <div class="policy-item"><span class="font-semibold">Lookup Code:</span> {{ client.ClientLookupCode }}</div>
              <div class="policy-item"><span class="font-semibold">Address:</span> {{ client.AccountValue.Address.Street1 }} {{ client.AccountValue.Address.City }}, {{ client.AccountValue.Address.StateOrProvinceCode }} {{ client.AccountValue.Address.ZipOrPostalCode }}</div>
            </div>
            <button
              *ngIf="clients?.length > 1"
              xilo-button
              class="ml-auto mt-2"
              size="large"
              color="primary"
              (click)="saveData(client)"
            >
              <span class="text-sm">Select Client</span>
            </button>
          </xilo-accordion-content>
        </xilo-accordion-panel>
      </xilo-accordion>
    </div>
    <xilo-accordion class="flex flex-col rounded bg-white mt-2 " *ngFor="let policy of policies; let i = index">
      <xilo-accordion-panel [open]="false">
        <xilo-accordion-title [noBorder]="true" paddingClass="p-3">Policy: {{returnPolicyTitle(policy) }}</xilo-accordion-title>
        <xilo-accordion-content paddingClass="px-3 pb-3">
          <div class="flex flex-row flex-wrap">
            <div class="policy-item"><span class="font-semibold">Policy Number:</span> {{ policy.PolicyNumber }}</div>
            <div class="policy-item"><span class="font-semibold">Policy Type Code:</span> {{ policy.PolicyTypeCode || policy.LineTypeCode }}</div>
            <div class="policy-item"><span class="font-semibold">Description:</span> {{ policy.Description }}</div>
            <div class="policy-item"><span class="font-semibold">Effective Date:</span> {{ policy.EffectiveDate | date }}</div>
            <div class="policy-item"><span class="font-semibold">Expiration Date:</span> {{ policy.ExpirationDate | date }}</div>
          </div>
          <button
            xilo-button
            class="ml-auto"
            size="large"
            color="primary"
            (click)="saveData(policy)"
          >
            <span class="text-sm">Select Policy</span>
          </button>
        </xilo-accordion-content>
      </xilo-accordion-panel>
    </xilo-accordion>
  </div>
  <div class="p-4">
    <button (click)="closeModal()" xilo-button size="large" color="primary-border">
      <span class="text-sm">Cancel</span>
    </button>
  </div>
</div>

